let impressionFired = false;
let recommendationsData = null;
let enrichedProductsMap = new Map(); // Maps product ID to enriched Shopify product data

document.addEventListener('DOMContentLoaded', async () => {
  const wrapper = document.getElementById('cart-related-products');
  const config = window.cartRelatedProductsConfig || {};

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    if (!cart.items || cart.items.length === 0) {
      if (wrapper) {
        wrapper.classList.add('hidden');
        wrapper.classList.remove('visible');
      }
      return;
    }

    // Show section immediately when cart has items
    if (wrapper) {
      wrapper.classList.add('visible');
      wrapper.classList.remove('hidden');
    }

    // Use only the most recently added cart item (cart.items[0])
    const mostRecentCartItem = cart.items[0];

    // Get all product IDs currently in cart to filter them out
    const cartProductIds = new Set();
    cart.items.forEach(item => {
      if (item.product_id) {
        cartProductIds.add(item.product_id.toString());
      }
    });

    // Fetch recommendations for the most recent cart item only
    const allRelatedProducts = [];
    const productRelationMap = new Map(); // Maps related product ID to source cart product

    const productId = mostRecentCartItem.product_id ? mostRecentCartItem.product_id.toString() : mostRecentCartItem.variant_id.toString();

    // Fallback function to load from cart-collection
    async function loadFromCartCollection() {
      try {
        const collectionResponse = await fetch('/collections/cart-collection/products.json?limit=20');
        
        if (collectionResponse.ok) {
          const collectionData = await collectionResponse.json();
          const collectionProducts = collectionData.products || [];
          
          // Filter out products already in cart and convert to expected format
          let fallbackCount = 0;
          for (const product of collectionProducts) {
            if (fallbackCount >= 10) break;
            
            const isInCart = cartProductIds.has(product.id.toString());
            const alreadyAdded = allRelatedProducts.some(p => p.id === product.id);
            
            if (!isInCart && !alreadyAdded) {
              // Convert Shopify product format to expected format
              const convertedProduct = {
                id: product.id,
                title: product.handle, // Use handle for fetching later
                images: product.images.map(img => ({ uri: img.src })),
                price: product.variants && product.variants.length > 0 ? product.variants[0].price : 0,
                handle: product.handle
              };
              
              allRelatedProducts.push(convertedProduct);
              productRelationMap.set(product.id, mostRecentCartItem);
              fallbackCount++;
            }
          }
        } else {
          console.warn('[Cart Related Products] cart-collection not found or accessible');
        }
      } catch (fallbackError) {
        console.warn('[Cart Related Products] Fallback to cart-collection failed:', fallbackError);
      }
    }

    // Check if GB API credentials are available, otherwise use fallback immediately
    if (!window.groupbyCustomerId || !window.groupbyKey) {
      await loadFromCartCollection();
      recommendationsData = {
        products: allRelatedProducts,
        modelName: 'cart_collection_fallback',
        origin: 'Cart',
        contextualProductId: productId,
        totalRecords: allRelatedProducts.length
      };
    } else {
      try {
        const visitorId = getVisitorId() || "anonymous";
      
      const recsResponse = await fetch('https://recsapi.shp.groupbycloud.com/api/recommendation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Groupby-Customer-Id': window.groupbyCustomerId,
          'authorization': window.groupbyKey
        },
        body: JSON.stringify({
          collection: "Production",
          name: "frequently_bought_together",
          visitorId: visitorId,
          ...(window.groupbyLoginId ? { loginId: window.groupbyLoginId } : {}),
          productID: productId,
          eventType: "detail-page-view",
          limit: 20,
          fields: ["id", "title", "images", "price", "handle", "sku"]
        })
      });

        if (recsResponse.ok) {
          let recsData = null;
          try {
            recsData = await recsResponse.json();
          } catch (parseErr) {
            console.warn('[Cart Related Products] JSON parse error:', parseErr);
            await loadFromCartCollection();
          }

          if (recsData) {
            const products = recsData?.products || [];
            if (!products.length) {
              console.warn('[Cart Related Products] No recs from API; using fallback collection');
              await loadFromCartCollection();
            } else {
              // Filter out products already in cart and limit to 10 products
              let addedCount = 0;
              for (const product of products) {
                if (addedCount >= 10) break;
                const isInCart = cartProductIds.has(product.id.toString());
                const alreadyAdded = allRelatedProducts.some(p => p.id === product.id);
                if (!isInCart && !alreadyAdded) {
                  allRelatedProducts.push(product);
                  productRelationMap.set(product.id, mostRecentCartItem);
                  addedCount++;
                }
              }
              if (addedCount === 0) {
                console.warn('[Cart Related Products] Recs filtered out; using fallback collection');
                await loadFromCartCollection();
              }
            }
          }
        } else {
          console.warn('[Cart Related Products] Recs API non-OK status:', recsResponse.status, await recsResponse.text().catch(()=>''));
          await loadFromCartCollection();
        }
    } catch (error) {
      console.warn('[Cart Related Products] Error fetching recommendations:', error);
      
      // Fallback: Fetch products from cart-collection when GB API fails
      await loadFromCartCollection();
    }

    if (allRelatedProducts.length === 0) {
      return;
    }

    // Store recommendations data for impression tracking
    recommendationsData = {
      products: allRelatedProducts,
      modelName: 'frequently_bought_together',
      origin: 'Cart',
      contextualProductId: productId,
      totalRecords: allRelatedProducts.length
    };

    // Prepare container for progressive rendering but keep loading state
    const container = document.getElementById('cart-recommendation-list');
    if (!container) {
      console.error('[Cart Related Products] Container not found');
      return;
    }
    // Keep loading cards visible until products are rendered

    // Function to fetch single product with metafields concurrently
    async function fetchProductWithMetafields(apiProduct) {
      const productHandle = apiProduct.title;

      try {
        // Fetch product data and metafields concurrently
        const [productResponse, metafieldsResponse] = await Promise.all([
          fetch(`/products/${productHandle}.js`).catch(() => null),
          fetch(`/products/${productHandle}?view=metafields`).catch(() => null)
        ]);

        let shopifyProduct = null;

        // Handle product data
        if (productResponse && productResponse.ok) {
          shopifyProduct = await productResponse.json();
        } else {
          // Fallback to ID-based fetch
          try {
            const fallbackResponse = await fetch(`/products/${apiProduct.id}.js`);
            if (fallbackResponse.ok) {
              shopifyProduct = await fallbackResponse.json();
            }
          } catch (fallbackError) {
            console.warn('[Cart Related Products] Could not fetch product:', apiProduct.id);
            return null;
          }
        }

        if (!shopifyProduct) return null;

        // Add API response data
        shopifyProduct.apiImages = apiProduct.images;
        shopifyProduct.relatedToCartItem = productRelationMap.get(apiProduct.id);

        // Handle metafields (non-blocking)
        if (metafieldsResponse && metafieldsResponse.ok) {
          try {
            const metafieldsText = await metafieldsResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(metafieldsText, 'text/html');

            const qtyIncrementsElement = doc.querySelector('[data-qty-increments]');
            const customOptionsElement = doc.querySelector('[data-custom-options]');
            const minCartQtyElement = doc.querySelector('[data-min-cart-qty]');

            if (qtyIncrementsElement || customOptionsElement || minCartQtyElement) {
              if (!shopifyProduct.metafields) shopifyProduct.metafields = {};
              if (!shopifyProduct.metafields.custom) shopifyProduct.metafields.custom = {};

              if (qtyIncrementsElement) {
                shopifyProduct.metafields.custom.qty_increments = parseInt(qtyIncrementsElement.getAttribute('data-qty-increments'));
              }
              if (customOptionsElement) {
                shopifyProduct.metafields.custom.custom_options_form = customOptionsElement.getAttribute('data-custom-options');
              }
              if (minCartQtyElement) {
                shopifyProduct.metafields.custom.min_cart_qty = parseInt(minCartQtyElement.getAttribute('data-min-cart-qty'));
              }
            }
          } catch (metaError) {
            console.warn('[Cart Related Products] Could not parse metafields:', metaError);
          }
        }

        return shopifyProduct;
      } catch (error) {
        console.warn('[Cart Related Products] Error fetching product:', apiProduct.id, error);
        return null;
      }
    }

    // Fetch all products concurrently with progressive rendering
    const productPromises = allRelatedProducts.map(fetchProductWithMetafields);

    // Render products as they become available
    let renderedCount = 0;
    for (let i = 0; i < productPromises.length; i++) {
      try {
        const shopifyProduct = await productPromises[i];
        if (shopifyProduct && shopifyProduct.available && renderedCount < 10) {
          // Store enriched product data for impression tracking
          enrichedProductsMap.set(shopifyProduct.id, shopifyProduct);
          renderProductCard(shopifyProduct, renderedCount);
          renderedCount++;
        }
      } catch (error) {
        console.warn('[Cart Related Products] Error rendering product:', error);
      }
    }

    // Remove loading state and loading cards after all products are rendered
    container.classList.remove('loading-state');
    const loadingCards = container.querySelectorAll('.loading-card');
    loadingCards.forEach(card => card.remove());

    // Show message if no products were rendered
    if (renderedCount === 0) {
      container.innerHTML = '<li class="grid__item"><p>No related products found.</p></li>';
    }

    // Function to render individual product card progressively
    function renderProductCard(product, index) {
      const li = document.createElement('li');
      li.className = 'grid__item slider__slide';

      if (config.animationsRevealOnScroll) {
        li.classList.add('scroll-trigger', 'animate--slide-in');
        li.setAttribute('data-cascade', '');
        li.classList.add(`animation-order-${index + 1}`);
      }

      // Render product card using the same structure as featured collection
      const cardHtml = renderProductCardHtml(product, 'cart-related', {
        show_vendor: config.showVendor,
        enable_quick_add: config.enableQuickAdd
      });
      li.innerHTML = cardHtml;

      // Remove the first loading card and replace it with the actual product
      const firstLoadingCard = container.querySelector('.loading-card');
      if (firstLoadingCard) {
        container.replaceChild(li, firstLoadingCard);
      } else {
        container.appendChild(li);
      }

      // Initialize/update slider navigation after each new card
      if (index === 0 || (index + 1) % 2 === 0) { // Update navigation every 2 cards
        initializeSliderNavigation();
      }
    }

    // Add event listeners for cart forms
    setupCartFormHandlers();
    
    // Update retail prices for cart-related products
    updateRetailPricesForCartRelated();

    // Add resize listener to handle mobile/desktop switching
    window.addEventListener('resize', () => {
      initializeSliderNavigation();
    });

    // Setup Intersection Observer for impression tracking
    setupImpressionTracking();
    }

  } catch (err) {
    console.error('[Cart Related Products] Error:', err);
    // Show error message in container (wrapper should already be visible)
    const container = document.getElementById('cart-recommendation-list');
    if (container) {
      container.innerHTML = '<li class="grid__item"><p>Error loading related products.</p></li>';
    }
  }
});

function setupCartFormHandlers() {
  document.addEventListener('submit', function(event) {
    if (event.target.classList.contains('cart-related-form')) {
      event.preventDefault();
      handleCartFormSubmit(event.target);
    }
  });
}

async function handleCartFormSubmit(form) {
  const button = form.querySelector('button[type="submit"]');
  const spinner = form.querySelector('.loading__spinner');
  const variantId = form.dataset.variantId;
  const productTitle = button.dataset.productTitle;

  // Show loading state
  button.disabled = true;
  if (spinner) {
    spinner.classList.remove('hidden');
  }

  // Collect all form data including properties
  const formData = new FormData(form);
  const requestBody = {
    id: variantId,
    quantity: 1
  };
  
  // Add properties if they exist
  const properties = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[') && key.endsWith(']')) {
      const propName = key.slice(11, -1); // Remove 'properties[' and ']'
      properties[propName] = value;
    }
  }
  
  if (Object.keys(properties).length > 0) {
    requestBody.properties = properties;
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });

    if (response.ok) {
      const cartData = await response.json().catch(() => null);
      if (cartData && typeof sendAddToCartBeacon === 'function') {
        const items = Array.isArray(cartData.items) ? cartData.items
          : Array.isArray(cartData) ? cartData
          : [cartData];
        await sendAddToCartBeacon(items);
      }
      window.location.reload();
    } else {
      throw new Error('Failed to add to cart');
    }
  } catch (error) {
    console.error('[Cart Related Products] Error adding to cart:', error);
    alert('Failed to add product to cart. Please try again.');
  } finally {
    // Hide loading state
    button.disabled = false;
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }
}

// Helper function to generate srcset like card-product.liquid
function generateSrcSet(media) {
  if (!media || !media.src) return '';
  
  const baseSrc = media.src;
  const width = media.width || 533;
  let srcSet = [];
  
  // Generate srcset based on available widths (same as card-product.liquid)
  const widths = [165, 360, 533, 720, 940, 1066];
  
  widths.forEach(w => {
    if (width >= w) {
      const resizedSrc = baseSrc.replace(/\.(jpg|jpeg|png|webp)$/i, `_${w}x${w}.$1`);
      srcSet.push(`${resizedSrc} ${w}w`);
    }
  });
  
  // Add original size
  srcSet.push(`${baseSrc} ${width}w`);
  
  return srcSet.join(', ');
}

function renderProductCardHtml(product, sectionId, settings) {
  const config = window.cartRelatedProductsConfig || {};

  // Use the same card-product structure as featured collection
  const ratio = product.featured_media ? product.featured_media.aspect_ratio || 1 : 1;
  
  // Helper function to get ratio class
  function getRatioClass(ratio) {
    const percentage = (1 / ratio * 100);
    if (percentage >= 95) return 'ratio-100';
    if (percentage >= 70) return 'ratio-75';
    if (percentage >= 60) return 'ratio-66';
    if (percentage >= 45) return 'ratio-50';
    return 'ratio-100'; // fallback
  }
  
  const ratioClass = getRatioClass(ratio);
  const showQuickAdd = settings.enable_quick_add && product.available;
  const showVendor = settings.show_vendor;

  // Get SKU from first variant
  const sku = product.variants && product.variants.length > 0 ? product.variants[0].sku : '';

  // Handle pricing
  let priceHtml = '';
  if (product.variants && product.variants.length > 1) {
    const prices = product.variants.map(v => v.price).filter(p => p > 0);
    const lowestPrice = Math.min(...prices);
    priceHtml = `<span class="price-item price-item--regular">From $${(lowestPrice / 100).toFixed(2)}</span>`;
  } else {
    const compareAtPrice = product.compare_at_price;
    const price = product.price;

    priceHtml = `<span class="price-item price-item--regular">$${(price / 100).toFixed(2)}</span>`;
  }

  // Handle image - use featured_media like card-product.liquid
  let imageHtml = '';

  // Priority 1: Use Shopify's featured_media (same as card-product.liquid)
  if (product.featured_media && product.featured_media.src) {
    const media = product.featured_media;
    imageHtml = `
      <img srcset="${generateSrcSet(media)}"
           src="${media.src.replace('.jpg', '_533x533.jpg').replace('.png', '_533x533.png').replace('.webp', '_533x533.webp')}"
           sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
           alt="${product.title || 'Product image'}"
           loading="lazy"
           class="motion-reduce"
           width="${media.width || 533}"
           height="${media.height || 533}">
    `;
  }
  // Priority 2: Use Shopify's first media item
  else if (product.media && product.media.length > 0 && product.media[0].src) {
    const media = product.media[0];
    imageHtml = `
      <img srcset="${generateSrcSet(media)}"
           src="${media.src.replace('.jpg', '_533x533.jpg').replace('.png', '_533x533.png').replace('.webp', '_533x533.webp')}"
           sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
           alt="${product.title || 'Product image'}"
           loading="lazy"
           class="motion-reduce"
           width="${media.width || 533}"
           height="${media.height || 533}">
    `;
  }
  // Priority 3: Use featured_image (fallback)
  else if (product.featured_image && product.featured_image.src) {
    imageHtml = `
      <img src="${product.featured_image.src}"
           alt="${product.title || 'Product image'}"
           loading="lazy"
           class="motion-reduce"
           width="533"
           height="533">
    `;
  }
  // Priority 4: Use first image (fallback)
  else if (product.images && product.images.length > 0 && product.images[0].src) {
    imageHtml = `
      <img src="${product.images[0].src}"
           alt="${product.title || 'Product image'}"
           loading="lazy"
           class="motion-reduce"
           width="533"
           height="533">
    `;
  }
  // Priority 5: Fallback to GroupBy API images (lowest priority)
  else if (product.apiImages && product.apiImages.length > 0 && product.apiImages[0].uri) {
    imageHtml = `
      <img src="${product.apiImages[0].uri}"
           alt="${product.title || 'Product image'}"
           loading="lazy"
           class="motion-reduce"
           width="533"
           height="533">
    `;
  } else {
    imageHtml = `<div class="placeholder-svg">No image available</div>`;
  }

  // Handle quick add button
  let buttonHtml = '';
  if (showQuickAdd) {
    const hasMultipleVariants = product.variants && product.variants.length > 1;
    const hasCustomOptions = product.metafields && product.metafields.custom && product.metafields.custom.custom_options_form;
    const qtyIncrements = product.metafields && product.metafields.custom && product.metafields.custom.qty_increments;
    const minCartQty = product.metafields && product.metafields.custom && product.metafields.custom.min_cart_qty;
    const hasQtyIncrements = qtyIncrements && parseInt(qtyIncrements) > 1;
    const hasMinCartQty = minCartQty && parseInt(minCartQty) > 1;

    if (hasMultipleVariants || hasCustomOptions || hasQtyIncrements || hasMinCartQty) {
      buttonHtml = `
        <div class="quick-add no-js-hidden" data-link-no-child>
          <a href="${product.url}" class="quick-add__submit button add-to-cart__button button--full-width button--secondary" aria-label="Choose ${hasQtyIncrements || hasMinCartQty ? 'quantity' : 'options'} for ${product.title}">
            <span>${hasQtyIncrements || hasMinCartQty ? 'Choose quantity' : 'Choose options'}</span>
          </a>
        </div>
      `;
    } else if (product.variants && product.variants[0]) {
      buttonHtml = `
        <div class="quick-add no-js-hidden" data-link-no-child>
          <form class="form cart-related-form" action="/cart/add" method="post" enctype="multipart/form-data" novalidate="novalidate" data-product-id="${product.id}" data-variant-id="${product.variants[0].id}" ${product.compare_at_price && product.compare_at_price > product.price ? `data-sale-price="$${(product.compare_at_price / 100).toFixed(2)}"` : ''}>
            <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
            <button type="submit" name="add" class="quick-add__submit button add-to-cart__button button--full-width button--secondary" aria-label="Add to cart" data-product-title="${product.title}">
              <span>Add to cart</span>
              <div class="loading__spinner hidden">
                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </form>
        </div>
      `;
    }
  }

  // Generate card classes based on config
  const cardClasses = config.cardStyle === 'card' ? `card--${config.cardStyle} color-${config.cardColorScheme} gradient` : `card--${config.cardStyle}`;
  const cardInnerClasses = config.cardStyle === 'standard' ? `color-${config.cardColorScheme} gradient` : '';

  return `
    <div class="card-wrapper product-card-wrapper underline-links-hover">
      <div class="card ${cardClasses} card--media ${ratioClass}" data-link-parent>
        <div class="card__inner ${cardInnerClasses} ratio ${ratioClass}">
          <a href="${product.url}" class="full-unstyled-link" tabindex="-1" aria-hidden="true">
            <div class="card__media cart-related">
              <div class="media media--transparent media--hover-effect">
                ${imageHtml}
              </div>
            </div>
          </a>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading" id="title-${sectionId}-${product.id}">
                <a href="${product.url}" id="StandardCardNoMediaLink-${sectionId}-${product.id}" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-${sectionId}-${product.id}">
                  ${product.title || 'Product Title'}
                </a>
              </h3>
            </div>
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading h5" id="title-${sectionId}-${product.id}">
              ${showVendor ? `
                <span class="visually-hidden">Vendor</span>
                <div class="card__heading-product-title-wrapper">
                  <a href="${product.url}" id="CardLink-${sectionId}-${product.id}" class="full-unstyled-link" data-link-child>
                    <span class="card__heading-product-vendor">${product.vendor || ''}</span>
                    <span class="card__heading-product-title-">- ${product.title || 'Product Title'}</span>
                  </a>
                </div>
              ` : `
                <div class="card__heading-product-title-wrapper">
                  <a href="${product.url}" id="CardLink-${sectionId}-${product.id}" class="full-unstyled-link" data-link-child>
                    <span class="card__heading-product-title-">${product.title || 'Product Title'}</span>
                  </a>
                </div>
              `}
            </h3>
            <div class="card__product-sku">
              <span class="card__product-sku_title">SKU:</span> <span>${sku}</span>
            </div>
            <div class="card-information price">
              <div class="price">
                <div class="price__container">
                  ${priceHtml}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ${buttonHtml}
    </div>
  `;
}

// Update retail prices for cart-related products
function updateRetailPricesForCartRelated() {
  // Find all cart-related forms
  const cartRelatedForms = document.querySelectorAll('.cart-related-form');
  
  cartRelatedForms.forEach(form => {
    // Get product and variant information
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    const variantId = variantInput.value.replace(/\D/g, '');
    const productId = form.dataset.productId;
    
    // Get current price from the card's price element
    let currentPrice = null;
    const productCard = form.closest('.card-wrapper');
    if (productCard) {
      const priceElement = productCard.querySelector('.price .money');
      if (priceElement) {
        const priceText = priceElement.textContent.replace(/[$,]/g, '');
        const price = parseFloat(priceText);
        if (!isNaN(price)) {
          currentPrice = Math.round(price * 100); // Convert to cents
        }
      }
    }
    
    if (variantId && productId) {
      // Call retail price function for this specific cart-related form
      fetchRetailPriceForCartRelated(productId, variantId, form, currentPrice);
    }
  });
}

// Fetch retail price for cart-related products
function fetchRetailPriceForCartRelated(productId, variantId, form, currentPrice) {
  const baseURL = window.apiUrl;
  return fetch(`${baseURL}/storefront/products/${productId}/retail-prices`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        const variant = data.variants.find(v => {
          const rawId = v.id.toString().split('/').pop();
          return rawId === variantId;
        });

        if (!variant || isNaN(parseFloat(variant.price))) {
          // Remove retail price property from this specific form
          const input = form.querySelector('#RetailPriceHidden');
          if (input) input.remove();
          return;
        }

        let compareAtPrice = null;

        const parsedRetailPrice = parseFloat(variant.price);
        if(variant.compare_at_price !== null && variant.compare_at_price > variant_price) {
          compareAtPrice =  parseFloat(variant.compare_at_price)
        }

        // Add retail price property to this specific form only
        let input = form.querySelector('#RetailPriceHidden');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_Retail Price]';
          input.id = 'RetailPriceHidden';
          form.appendChild(input);
        }
        input.value = parsedRetailPrice.toString();

        let salePriceInput = form.querySlector('#RegularPriceHidden');
        if (!salePriceInput && compareAtPrice) {
          salePriceInput = document.createElement('input');
          salePriceInput.type = 'hidden';
          salePriceInput.name = 'properties[Regular price]';
          salePriceInput.id = 'RegularPriceHidden';
          form.appendChild(input);
          salePriceInput.value = parsedRetailPrice.toString();
        }
        // Get variant price for comparison
        let variantPrice = null;
        if (currentPrice !== undefined && currentPrice !== null) {
          variantPrice = parseFloat(currentPrice) / 100;
        }

        // Note: Only add the property, don't display retail price on cart-related products
      })
      .catch(error => {
        console.error('Error fetching retail price for cart-related product:', error);
        const input = form?.querySelector('#RetailPriceHidden');
        if (input) input.remove();
      });
}

function initializeSliderNavigation() {
  const slider = document.querySelector('.cart-slider');
  const prevButton = document.querySelector('.cart-related-products .slider-button--prev');
  const nextButton = document.querySelector('.cart-related-products .slider-button--next');

  if (!slider || !prevButton || !nextButton) return;

  function moveSlider(direction) {
    const slides = slider.querySelectorAll('.slider__slide');
    if (slides.length === 0) return;
    
    const slideWidth = slides[0].offsetWidth;
    const currentScroll = slider.scrollLeft;

    if (direction === 'next') {
      slider.scrollLeft = currentScroll + slideWidth;
    } else if (direction === 'prev') {
      slider.scrollLeft = currentScroll - slideWidth;
    }
  }

  function updateButtons() {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
    const currentScrollLeft = slider.scrollLeft;
    
    prevButton.disabled = currentScrollLeft <= 0;
    nextButton.disabled = currentScrollLeft >= maxScrollLeft - 1;
  }

  // Button event listeners
  prevButton.addEventListener('click', () => {
    moveSlider('prev');
  });

  nextButton.addEventListener('click', () => {
    moveSlider('next');
  });

  // Update button states on scroll
  slider.addEventListener('scroll', updateButtons);

  // Allow page scrolling when cursor is on slider
  let isDesktop = window.innerWidth >= 990;
  
  if (isDesktop) {
    // Allow wheel scrolling to scroll the page, not the slider
    slider.addEventListener('wheel', (e) => {
      // Don't prevent default - let the page scroll normally
      // Just prevent the slider itself from scrolling
      slider.classList.add('overflow-hidden');
      slider.classList.remove('overflow-auto');
      
      // Re-enable slider scrolling after a short delay
      setTimeout(() => {
        slider.classList.add('overflow-auto');
        slider.classList.remove('overflow-hidden');
      }, 100);
    });

    // Prevent touch scrolling on desktop
    slider.addEventListener('touchstart', (e) => {
      e.preventDefault();
    }, { passive: false });
    
    slider.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, { passive: false });
  }

  // Enable touch scrolling only on mobile
  if (!isDesktop) {
    let startX = 0;
    let scrollStart = 0;
    
    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      scrollStart = slider.scrollLeft;
    }, { passive: true });
    
    slider.addEventListener('touchmove', (e) => {
      if (!startX) return;
      
      const currentX = e.touches[0].clientX;
      const diffX = startX - currentX;
      slider.scrollLeft = scrollStart + diffX;
    }, { passive: true });
    
    slider.addEventListener('touchend', () => {
      startX = 0;
      scrollStart = 0;
    }, { passive: true });
  }

  // Initial button state
  updateButtons();

  // Update on window resize
  window.addEventListener('resize', () => {
    isDesktop = window.innerWidth >= 990;
    updateButtons();
  });
}

function setupImpressionTracking() {
  const wrapper = document.getElementById('cart-related-products');

  if (!wrapper || !recommendationsData) {
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !impressionFired && recommendationsData) {
        impressionFired = true;
        sendImpressionEvent(recommendationsData);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  observer.observe(wrapper);
}

async function sendImpressionEvent(data) {
  try {
    const visitorId = getVisitorId() || 'anonymous';
    const sessionId = sessionStorage.getItem('session_id') || '';

    if (!window.groupbyCustomerId || !window.groupbyKey) {
      console.warn('[Cart Related Products] GroupBy tracking not configured');
      return;
    }

    const hasMap = typeof enrichedProductsMap !== 'undefined';

    const products = data.products.map(product => {
      const enrichedProduct = hasMap
          ? (enrichedProductsMap.get(product.id) || enrichedProductsMap.get(parseInt(product.id)))
          : null;

      let price = 0;
      if (enrichedProduct?.price) {
        price = parseFloat(enrichedProduct.price) / 100;
      } else if (product.price) {
        price = parseFloat(product.price);
        if (isNaN(price)) price = 0;
        if (price > 1000) price = price / 100;
      }

      const sku = enrichedProduct?.variants?.[0]?.sku || product.sku || '';
      const category = enrichedProduct?.product_type || product.product_type || '';

      return {
        productId: product.id?.toString() || '',
        title: enrichedProduct?.title || product.title || product.handle || '',
        ...(category ? { category } : {}),
        sku,
        price: price,
        collection: 'Production'
      };
    }).filter(p => p.sku);

    if (products.length === 0) {
      console.warn('[Cart Related Products] No products with valid SKU — impression beacon not sent');
      return;
    }

    const metadata = [
      { key: 'recs_model_name', value: data.modelName || '' },
      { key: 'origin', value: data.origin || 'Cart' },
      { key: 'contextual_productId', value: data.contextualProductId || '' },
      { key: 'totalrecords', value: data.totalRecords?.toString() || '0' }
    ];

    const payload = {
      impression: {
        impressionType: 'recommendation',
        products: products
      },
      metadata,
      clientVersion: { raw: '5.4.0' },
      eventType: 'impression',
      customer: {
        id: window.groupbyCustomerId,
        area: 'Production'
      },
      visit: {
        customerData: {
          ...(window.groupbyLoginId ? { loginId: window.groupbyLoginId } : {}),
          sessionId,
          visitorId
        },
        generated: {
          uri: window.location.href,
          timezoneOffset: new Date().getTimezoneOffset(),
          localTime: new Date().toISOString()
        }
      }
    };

    await fetch('https://events.shp.groupbycloud.com/wisdom/v2/pixel', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Groupby-Customer-Id': window.groupbyCustomerId
      },
      body: JSON.stringify(payload),
      mode: 'no-cors'
    });
  } catch (error) {
    console.error('[Cart Related Products] Error sending impression event:', error);
  }
}
